export default __webpack_public_path__ + "static/media/testimonial2.3ecaac48.png";